/* eslint-disable react-refresh/only-export-components */
import React from 'react';
import { ComponentRenderer } from '../../components/ComponentRenderer';
import type { Component } from '../../schemas/validation';
import { processLayoutComponents } from '../../utils/templateUtils';

export { processLayoutComponents };

interface LayoutComponentsProps {
  components: Component[];
  position: 'header' | 'footer';
}

export const LayoutComponents: React.FC<LayoutComponentsProps> = ({ components, position }) => {
  if (components.length === 0) {
    return null;
  }

  return (
    <div className={`layout-${position}-components`}>
      {components
        .filter((c: any) => c.visible !== false)
        .map((component: any) => (
          <ComponentRenderer key={component.id} component={component} isEditing={false} />
        ))}
    </div>
  );
};
